import React from "react";

/**
 * Helkar & Associates logo.
 * variant: "full" (mark + wordmark) | "mark" (emblem only) | "stacked"
 * Colors inherit from currentColor; gold accents use the --gold token.
 */
export function LogoMark({ className = "h-10 w-10", title = "Helkar & Associates" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} role="img" aria-label={title} fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* outer ring */}
      <circle cx="50" cy="50" r="47" stroke="currentColor" strokeOpacity="0.9" strokeWidth="1.4" />
      <circle cx="50" cy="50" r="43" stroke="hsl(var(--gold))" strokeOpacity="0.55" strokeWidth="0.8" />

      {/* scales of justice */}
      <g stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
        {/* central pole */}
        <line x1="50" y1="24" x2="50" y2="70" />
        {/* top pommel */}
        <circle cx="50" cy="22" r="2.6" fill="hsl(var(--gold))" stroke="none" />
        {/* beam */}
        <line x1="28" y1="34" x2="72" y2="34" />
        {/* left hangers */}
        <line x1="28" y1="34" x2="21" y2="49" />
        <line x1="28" y1="34" x2="35" y2="49" />
        {/* right hangers */}
        <line x1="72" y1="34" x2="65" y2="49" />
        <line x1="72" y1="34" x2="79" y2="49" />
        {/* left pan */}
        <path d="M20 49 Q28 61 36 49" fill="none" stroke="hsl(var(--gold))" strokeWidth="2" />
        {/* right pan */}
        <path d="M64 49 Q72 61 80 49" fill="none" stroke="hsl(var(--gold))" strokeWidth="2" />
        {/* base */}
        <line x1="41" y1="70" x2="59" y2="70" />
        <line x1="44" y1="76" x2="56" y2="76" />
      </g>
    </svg>
  );
}

export default function Logo({ variant = "full", className = "", markClassName = "h-9 w-9 md:h-10 md:w-10", textClassName = "" }) {
  if (variant === "mark") {
    return <LogoMark className={markClassName} />;
  }
  if (variant === "stacked") {
    return (
      <span className={`flex flex-col items-center gap-2 ${className}`}>
        <LogoMark className={markClassName} />
        <span className={`serif tracking-tight leading-none ${textClassName}`}>
          Helkar <span className="text-gold">&amp;</span> Associates
        </span>
      </span>
    );
  }
  return (
    <span className={`flex items-center gap-3 ${className}`}>
      <LogoMark className={markClassName} />
      <span className={`serif tracking-tight leading-none whitespace-nowrap ${textClassName || "text-xl md:text-2xl"}`}>
        Helkar <span className="text-gold">&amp;</span> Associates
      </span>
    </span>
  );
}
